import React from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { CustomInput } from "components";
import RadioButton from "components/radioButton";
import { float6Normalizer } from "validators";
import {
	applyValidatorsIf,
	floatToSixValidation,
	maxValue100,
	onlyPercentToSixFloat,
} from "validators/validation";

import styles from "./tabsChoose.module.scss";

const ThreeTier = ({ setCurrentValueInField, isPaperApplication }) => {
	const handleThreeTierTemplate = (_e, newValue, _previousValue) => {
		setCurrentValueInField(true);
	};
	return (
		<div>
			<div className={styles.subHeader}>3-Tier</div>
			<Row>
				<Col md={5}>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(
							(value, allValues) =>
								allValues.feeProgram === "ThreeTier",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						label="Qual V/MC/D, %"
						name="threeTierQualVMCD"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleThreeTierTemplate}
						hideRequiredMark={isPaperApplication}
					/>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(
							(value, allValues) =>
								allValues.feeProgram === "ThreeTier",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						label="Qual Amex, %"
						name="threeTierQualAmex"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleThreeTierTemplate}
						hideRequiredMark={isPaperApplication}
					/>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(
							(value, allValues) =>
								allValues.feeProgram === "ThreeTier",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						label="Qual Offline Debit, %"
						name="threeTierQualOfflineDebit"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleThreeTierTemplate}
						hideRequiredMark={isPaperApplication}
					/>
				</Col>
				<Col md={{ span: 5, offset: 2 }}>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(
							(value, allValues) =>
								allValues.feeProgram === "ThreeTier",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						label="Mid-Qual V/MC/D, %"
						name="threeTierMidQualVMCD"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleThreeTierTemplate}
						hideRequiredMark={isPaperApplication}
					/>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(
							(value, allValues) =>
								allValues.feeProgram === "ThreeTier",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						label="Mid-Qual Amex, %"
						name="threeTierMidQualAmex"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleThreeTierTemplate}
						hideRequiredMark={isPaperApplication}
					/>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(
							(value, allValues) =>
								allValues.feeProgram === "ThreeTier",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						label="Mid-Qual Offline Debit, %"
						name="threeTierMidQualOfflineDebit"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleThreeTierTemplate}
						hideRequiredMark={isPaperApplication}
					/>
				</Col>
			</Row>
			<Row>
				<Col md={5}>
					<Field
						component={CustomInput}
						validate={applyValidatorsIf(
							(value, allValues) =>
								allValues.feeProgram === "ThreeTier",
						)([maxValue100, floatToSixValidation])}
						normalizeOnBlur={float6Normalizer}
						normalize={onlyPercentToSixFloat}
						label="Non-Qual V/MC/D, %"
						name="threeTierNonQualVMCD"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleThreeTierTemplate}
						hideRequiredMark={isPaperApplication}
					/>
					<Field
						component={CustomInput}
						validate={applyValidatorsIf(
							(value, allValues) =>
								allValues.feeProgram === "ThreeTier",
						)([maxValue100, floatToSixValidation])}
						normalizeOnBlur={float6Normalizer}
						normalize={onlyPercentToSixFloat}
						label="Non-Qual Amex, %"
						name="threeTierNonQualAmex"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleThreeTierTemplate}
						hideRequiredMark={isPaperApplication}
					/>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(
							(value, allValues) =>
								allValues.feeProgram === "ThreeTier",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						label="Non-Qual Offline Debit, %"
						name="threeTierNonQualOfflineDebit"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleThreeTierTemplate}
						hideRequiredMark={isPaperApplication}
					/>
				</Col>
			</Row>

			<div className={styles.addressTitle}>Pass Card Brand Fees</div>
			<Row>
				<Col md={12}>
					<div className="d-flex">
						<Field
							component={RadioButton}
							value="true"
							className={styles.radioButton}
							name="passCardBrandFees"
							label="Yes"
							type="radio"
							id="yesPassCardBrandFees"
						/>
						<Field
							component={RadioButton}
							value="false"
							className={styles.radioButton}
							name="passCardBrandFees"
							label="No"
							type="radio"
							id="noPassCardBrandFees"
						/>
					</div>
				</Col>
			</Row>
		</div>
	);
};

export default ThreeTier;
